var $$ = $$ || {};

$$.Config = {
	addCartUrl:       '/.ajax/add2Cart.php',
	removeCartUrl:    '/.ajax/deleteInCart.php',
	removeAllCartUrl: '/.ajax/clearCart.php',
	updateCartUrl:    '/.ajax/updateCart.php',
	deleteInCart:     '/.ajax/deleteInCart.php',
	addCoupon:        '/.ajax/addCoupon.php',
	confirmCity:      '/.ajax/confirm_city.php',
	changeDelivery:   '/.ajax/getListDelivery.php',
	search:           '/.ajax/search.php'
};
